module.exports = __webpack_public_path__ + "6209b58a.woff2";